/**
 * @file 列表页-操作区
 * @author alfielv
 */
import React from 'react';
import Toolbar from '../Toolbar';
export default (function (props) {
  var prefixCls = props.prefixCls,
      toolbarConfig = props.toolbarConfig;
  var left = toolbarConfig.left,
      right = toolbarConfig.right,
      className = toolbarConfig.className,
      leftClassName = toolbarConfig.leftClassName,
      rightClassName = toolbarConfig.rightClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__toolbar-area")
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: className,
    left: left,
    right: right,
    leftClassName: leftClassName,
    rightClassName: rightClassName
  }));
});